// react
import { useDispatch } from 'react-redux';

// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useNavigate } from '@tanstack/react-router';

// api
import {
  type PutAlarmConfigurationDto,
  usePutAlarmConfigurationMutation,
} from '@/api/generated/recalc/endpoints/v2/alarmConfiguration';

// components
import { showSnackbar } from '@/redux/snackbarSlice';

export function useUpdateAlarmConfiguration() {
  const { t } = useTranslation('alarms');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [putAlarmConfiguration, { isLoading: isUpdating }] =
    usePutAlarmConfigurationMutation();

  const updateAlarmConfiguration = async (
    alarmConfigurationId: number,
    updatePayload: PutAlarmConfigurationDto,
  ) => {
    const result = await putAlarmConfiguration({
      id: alarmConfigurationId,
      putAlarmConfigurationDto: updatePayload,
    });

    if (!('error' in result)) {
      dispatch(
        showSnackbar({
          message: t('messages.alarm_configuration_updated', {
            defaultValue: 'Alarm configuration updated successfully',
          }),
          severity: 'success',
        }),
      );

      navigate({ to: '..' });
      return true;
    }
    // Errors are handled globally by apiErrorMiddleware (snackbar + App Insights).
    return false;
  };

  return {
    updateAlarmConfiguration,
    isUpdating,
  };
}
